function loadCookieScript(configStore, window) {
  const { config, configurationKeys } = configStore;
  const cookieConsentId = config[configurationKeys.cookieConsentId];
  const cookieConsentClass = config[configurationKeys.cookieConsentClass];

  if (window.self !== window.top) return;

  const body = document.body;
  body.appendChild(
    document.createComment(
      'OneTrust Cookies Consent Notice start for http://driver.smartdrive.net'
    )
  );

  const scripts = [
    {
      id: 'otAutoBlock',
      type: 'text/javascript',
      src: `https://cdn.cookielaw.org/consent/${cookieConsentId}/OtAutoBlock.js`
    },
    {
      id: 'otSDKStub',
      type: 'text/javascript',
      src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
      charset: 'UTF-8',
      'data-domain-script': cookieConsentId
    },
    {
      id: 'optanon',
      type: 'text/javascript',
      text: 'function OptanonWrapper() { }'
    }
  ];

  scripts.forEach(attrs => {
    const script = document.createElement('script');
    Object.entries(attrs).forEach(([key, value]) => {
      if (key === 'src' || key === 'type' || key === 'id') {
        script[key] = value;
      } else if (key === 'text') {
        script.text = value;
      } else {
        script.setAttribute(key, value);
      }
    });
    body.appendChild(script);
  });

  body.appendChild(
    document.createComment(
      'OneTrust Cookies Consent Notice end for http://driver.smartdrive.net'
    )
  );

  // Add a hidden button with id "otSDKShowSettings" and class "ot-sdk-show-settings"
  // This ensures this button has event listener attached after DOM re-renders
  const showSettingsBtn = document.createElement('button');
  showSettingsBtn.id = 'otSDKShowSettings';
  showSettingsBtn.className = cookieConsentClass;
  showSettingsBtn.style.display = 'none';
  showSettingsBtn.style.opacity = 0;
  showSettingsBtn.style.visibility = 'hidden';
  body.appendChild(showSettingsBtn);
}

export default loadCookieScript;



// WEBPACK FOOTER //
// ./src/utils/loadCookieScript.js